import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const WarmtepompDuiven = () => {
  return <LocalServiceTemplate data={localServiceData['warmtepomp-duiven']} />;
};

export default WarmtepompDuiven;